import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Journal from "./sections/Journal";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <Journal />
      <Footer />
    </div>;
}